import React from 'react';
import { useSelector } from 'react-redux';

import SvgIcon from 'components/SvgIcon';
import { useWindowSizeDebounced } from 'src/hooks/useIsMobile';
import { selectSdkCallbackStorage } from 'selectors/selectors';
import { MixpanelEvents, SdkEvents } from 'constants/enums';
import MixpanelActions from 'src/utils/mixpanel';

import styles from './styles.model.scss';

const enum ToggleName {
  EXPAND = 'expand',
  MOBILE = 'mobile view',
}

const SVG_NAME = {
  EXPAND: 'arrowRight',
  MOBILE: 'arrowLeft',
};

const ToggleWindowSize = () => {
  const { isMobile, isExpanded } = useWindowSizeDebounced();

  const sdkCallbackStorage = useSelector(selectSdkCallbackStorage);
  const isSdk = sdkCallbackStorage.size > 0;
  const toggleView = sdkCallbackStorage.get(SdkEvents.TOGGLE_CHAT_WINDOW_SIZE);
  const handleToggleView = () => {
    if (toggleView) {
      MixpanelActions.track(MixpanelEvents.BUTTON_TAPPED, {
        button_text: isExpanded ? ToggleName.MOBILE : ToggleName.EXPAND,
        button_type: 'text',
        screen_name: 'chat window',
        screen_title: 'chat window',
      });
      toggleView({
        name: SdkEvents.TOGGLE_CHAT_WINDOW_SIZE,
      });
    }
  };

  if (isMobile || !isSdk) {
    return null;
  }

  return (
    <button
      type="button"
      className={styles.toggleWindowSize}
      onClick={handleToggleView}
    >
      {!isExpanded ? <SvgIcon id={SVG_NAME.MOBILE} color="none" /> : null}
      <span className={styles.toggleLabel}>
        {isExpanded ? ToggleName.MOBILE : ToggleName.EXPAND}
      </span>
      {isExpanded ? <SvgIcon id={SVG_NAME.EXPAND} color="none" /> : null}
    </button>
  );
};

export default React.memo(ToggleWindowSize);
